import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  userManagement: 'User management',
  hpeGreenLakeFlex: 'HPE GreenLake Flex Solutions',
  api: 'API',
  other: 'Other',
};

export const helpWithOptionsConsolidated: FormOptions = {
  userManagement: 'User management',
  // hpeGreenLakeML: 'HPE GreenLake for ML Ops',
  // hpeGreenLakeSAP: 'HPE GreenLake for SAP S/4HANA pe cdc',
  // hpeGreenLakeHPC: 'HPE Greenlake for HPC',
  // hpeGreenLakeMS: 'HPE GreenLake Management Services',
  // hpeGreenLakeAzure: 'HPE GreenLake for Azure Stak HCI',
  // hpeGreenLakeOpenShift: 'HPE GreenLake for RedHat OpenShift Container Platform',
  // hpeGreenLakeVCF: 'HPE GreenLake for Vmware Cloud Foundation (VCF)',
  api: 'API',
  other: 'Other',
};

export const userManagementOptions: string[] = [
  'Additional role access',
  'Application access',
  'Authentication/Authorization',
  'Console access',
  'No/Blank widget',
  'Password reset',
  'Portal access',
  'User activation',
];

export const severityOptions: string[] = [
  'High (widespread impact - business/timelines, etc)',
  'Medium (service impacted partially; not down)',
  'Low (no impact to business)',
];
